import { DropdownsData } from './types';

export const initialState: DropdownsData = {
  params: {
    builderSuperintendents: {},
    companies: {},
    divisions: {},
    inventoryItems: {},
    products: {},
    subtasksForFiles: {},
    tasks: {},
    users: {},
    workflows: {},
    primaryRole: '',
  },
};
